import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Checkbox } from '@mui/material';

export const OfferPartnerConsentSummary = ({ assignedConsents }) => {
  
  return (
    <div>
      {assignedConsents.map((consent, index) => {
        return (
          <Grid container spacing={1} key={index}>
            <Grid item xs={12}>
              <Checkbox style={{ paddingLeft: '0px' }} checked={true} value='1' disabled={true} />
              <span>{consent.name}</span>
            </Grid>
          </Grid>
        );
      })}
    </div>
  );
};

OfferPartnerConsentSummary.propTypes = {
  assignedConsents: PropTypes.array.isRequired
};

export default OfferPartnerConsentSummary;
